import { render, staticRenderFns } from "./el-steps.vue?vue&type=template&id=042d2a52"
import script from "./el-steps.vue?vue&type=script&lang=js"
export * from "./el-steps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports